module.exports = __webpack_public_path__ + "img/LTC-ability-06.5dba34d6.png";